import { useSyncExternalStore } from "react"

function fakeSubscribe() {
  return () => {}
}

// Check if code is running client-side, post-hydration.
export function useIsClient() {
  return useSyncExternalStore(
    fakeSubscribe,
    () => true, // runs client-side after hydration
    () => false, // runs server-side and initial hydration pass on client
  )
}
